import { styled } from "@linaria/react";
import { COLOR_GRAY_LIGHT } from "../../constants";
import { Aws, Kubernetes, Prometheus, ReactJS, Rust, Tokio, Typescript, WebAssembly as WSIcon } from "../icons";
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "cmczoq2"
});

function TechStack(): JSX.Element {
  return <Container>
      <Rust alt="Rust" />
      <Prometheus alt="Prometheus" />
      <Kubernetes alt="Kubernetes" />
      <Typescript alt="TypeScript" />
      <Tokio alt="Tokio" />
      <WSIcon alt="WebAssembly" />
      <Aws alt="Amazon Web Services" />
      <ReactJS alt="React" />
    </Container>;
}

export default TechStack;

require("../../../.linaria-cache/src/components/techStack/index.linaria.module.css");